import type { UserManagerSettings } from 'oidc-client-ts';
import { WebStorageStateStore } from 'oidc-client-ts';

const auth = '/auth/callback/keycloak';
const silent = '/auth/callback/keycloak-silent';

export const oidcConfig: UserManagerSettings = {
  authority: `${
    process.env.OIDC_DOMAIN || 'https://uat-access.identity.elsevier.com'
  }/realms/${process.env.OIDC_REALM || 'h'}`,
  client_id: process.env.OIDC_CLIENT_ID || 'gme-completeanatomy-webapp',
  redirect_uri: `${window.location.origin}${auth}`,
  silent_redirect_uri: `${window.location.origin}${silent}`,
  response_type: 'code',
  scope: 'openid profile email',
  post_logout_redirect_uri: `${window.location.origin}${auth}`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
};
